export const MIN_PERCENT = 0
export const MAX_PERCENT = 100

export enum Choice {
  Yes = 'Yes',
  No = 'No',
}

export const PARTNERSHIP_DETAILS_NA_DROPDOWN_KEY = 'partnershipDetailsNA'
